import React from "react";
import { useFormikContext } from "formik";
import CodePreview from "components/CodePreview";
import { getEmbedSnippet } from "utils/embed";
import { EMBED_META_SNIPPET, EMBED_CODE_ID } from "utils/constants/embed";
import { COPY_ACTION_TYPE } from "utils/constants/ui";
import SectionBezel from "components/SectionBezel";

const SNIPPET_CLASSES = {
  container: "w-100 bg-white ba hairline-1 br3 overflow-hidden",
  snippet: {
    pre: "code__pre--preview--small ma0 overflow-auto f6"
  }
};

const CodeFields = () => {
  const { values } = useFormikContext();

  return (
    <SectionBezel header="Code">
      <div className="f5 pb2 fw6">Body</div>
      <div className="f6 lh-copy">
        Copy and paste this snippet within the{" "}
        <span className="fw6 token-monospace">{`<body>`}</span> tag of the html
        where you will embed this page.
      </div>
      <div className="pt3" id={EMBED_CODE_ID}>
        <CodePreview
          hideCopyAction
          title=" "
          copyActionType={COPY_ACTION_TYPE.BUTTON}
          customClasses={SNIPPET_CLASSES}
          snippets={{
            html: getEmbedSnippet(values)
          }}
        />
      </div>
      <div className="pt3">
        <div className="f5 pb2 fw6">Head</div>
        <div className="f6 lh-copy">
          Copy and paste this snippet inside the{" "}
          <span className="fw6 token-monospace">{`<head>`}</span> tag of the
          html where you will embed this page. This ensures your embed is scaled
          correctly on mobile.
        </div>
        <div className="pt3">
          <CodePreview
            hideCopyAction
            title=" "
            copyActionType={COPY_ACTION_TYPE.BUTTON}
            customClasses={SNIPPET_CLASSES}
            snippets={{
              html: EMBED_META_SNIPPET
            }}
          />
        </div>
      </div>
    </SectionBezel>
  );
};
export default CodeFields;
